import { render, staticRenderFns } from "./IndexContent.vue?vue&type=template&id=e204aca0&scoped=true&"
import script from "./IndexContent.vue?vue&type=script&lang=js&"
export * from "./IndexContent.vue?vue&type=script&lang=js&"
import style0 from "./IndexContent.vue?vue&type=style&index=0&id=e204aca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e204aca0",
  null
  
)

export default component.exports